module.exports = "/_next/static/images/4fdab4e185077ff5e17d47bca24e34d0-gift-illustration@0.75x.png";